import { Box, Modal, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Overlay = styled(Box)(() => ({
  position: 'absolute',
  inset: 0,
  backgroundColor: 'rgba(0,0,0,0.85)',
}));

const PreviewFrame = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '90%',
  maxHeight: '90%',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `2px solid ${theme.palette.primary.main}`,
  boxShadow: '0 0 24px rgba(125,211,199,0.35)',

  '& img': {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '70vh',
    marginTop: theme.spacing(1),
  },
}));

export function ImagePreviewModal({
  open,
  onClose,
  title,
  imageUrl,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  imageUrl: string;
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <>
        <Overlay />
        <PreviewFrame>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: 'secondary.main', letterSpacing: '0.12em' }}
            >
              IMAGE PREVIEW
            </Typography>

            <Typography
              variant="subtitle2"
              sx={{
                color: 'primary.main',
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            >
              {title}
            </Typography>

            <Box
              component="button"
              onClick={onClose}
              sx={(theme) => ({
                all: 'unset',
                cursor: 'pointer',
                padding: theme.spacing(0.5, 1),
                border: `1px solid ${theme.palette.divider}`,
                color: theme.palette.text.secondary,
                fontSize: '0.7rem',
                '&:hover': {
                  color: theme.palette.primary.main,
                  borderColor: theme.palette.primary.main,
                },
              })}
            >
              CLOSE
            </Box>
          </Box>

          <img src={imageUrl} alt={title} />
        </PreviewFrame>
      </>
    </Modal>
  );
}
